import React from 'react';
import PageShell from '../components/PageShell';
import PageSection from '../components/page/PageSection';
import FaqList from '../components/page/FaqList';
import DirectionCard from '../components/services-index/DirectionCard';
import ChainPanel from '../components/services-index/ChainPanel';
import { serviceGroups, serviceMeta } from '../content/services';
import { servicesIndexCopy } from '../content/pages';
import { SITE } from '../components/Seo';

const ServicesIndex = () => {
  const listSchema = {
    '@type': 'ItemList',
    name: 'Юридичні послуги для медичного бізнесу',
    itemListElement: serviceMeta.map((m, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: m.h1,
      description: m.description,
      url: `${SITE}/poslugy/${m.slug}`
    }))
  };

  const faqSchema = {
    '@type': 'FAQPage',
    mainEntity: servicesIndexCopy.faq.map((f) => ({
      '@type': 'Question',
      name: f.q,
      acceptedAnswer: { '@type': 'Answer', text: f.a }
    }))
  };

  return (
    <PageShell
      title="Юридичні послуги для медичного бізнесу"
      description="Шість напрямків юридичного супроводу клінік: реєстрація бізнесу, ліцензування медичної практики, ЕСОЗ, документація, захист бренду та юридичний аутсорсинг."
      path="/poslugy"
      banner="/images/page-care-a71e1414.jpg"
      schema={[listSchema, faqSchema]}
      crumbs={[{ name: 'Послуги' }]}
      cta={{ source: 'poslugy' }}
      heading="Юридичні послуги для медичного бізнесу"
      lead="Ми беремо на себе всі юридичні та бюрократичні аспекти — від реєстрації бізнесу до ліцензії МОЗ, — щоб ви могли зосередитися на лікуванні пацієнтів та розвитку клініки."
    >
      <div className="page-container py-10 lg:py-14">
        {/*
          Напрямки — одразу під банером: по них сюди й приходять. Раніше над
          картками стояв вступ на три абзаци з переліком збоку, і на телефоні
          до першої картки треба було гортати півтора екрана.
        */}
        <PageSection caption="Шість напрямків" title="Оберіть свій напрямок">
          <ul className="list-none grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-5 lg:gap-6">
            {serviceGroups.map((group, idx) => (
              <li key={group.title} className="md:row-span-5 md:grid md:grid-rows-subgrid md:gap-y-0">
                <DirectionCard group={group} meta={serviceMeta[idx]} index={idx} />
              </li>
            ))}
          </ul>
        </PageSection>

        <ChainPanel
          className="mt-14 lg:mt-20"
          checklist={servicesIndexCopy.checklist}
          text={servicesIndexCopy.intro[1]}
        />

        {/*
          Відповіді розгорнуті, а не сховані під клік: людина з пошуку приходить
          саме за конкретним питанням, і текст під кліком вона не побачить, а
          Google вважає його менш вагомим за видимий. Переліком, а не сіткою
          карток: відповіді різної довжини, і картки в парі закінчувалися на
          різній висоті, а п'ята лишалася сама з порожньою половиною поруч.
        */}
        <PageSection
          caption="Перш ніж звернутися"
          title="Часті запитання"
          link={{ to: '/pytannya', label: 'Усі запитання' }}
        >
          <FaqList variant="list" items={servicesIndexCopy.faq} />
        </PageSection>
      </div>
    </PageShell>
  );
};

export default ServicesIndex;
